import React from 'react';
import styled from 'styled-components';
import {
  AIScenarioForm,
  FormData,
  ChatBotTemplate
} from '~/training/sequence/templates/items/chatBot/components/forms/AIScenarioForm';
import { useFormSubmission } from '~/training/sequence/templates/items/chatBot/hooks/useFormSubmission';
import { validateChatBotForm } from '~/training/sequence/templates/items/chatBot/utils/validation';

const FormContainer = styled.div`
  padding: 40px 76px;
  background: white;
  border-radius: 16px;
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-family: ralewayBold;
  font-size: 18px;
  line-height: 1.5;
  color: #2e2e2e;
  margin: 6px 0px 29px;
`;

export interface AIScenarioInlineFormProps {
  formData: FormData;
  onFormDataChange: (formData: FormData) => void;
  onSubmit: (formData: FormData) => void;
  templates?: ChatBotTemplate[];
  isSubmitting?: boolean;
}

export const AIScenarioInlineForm: React.FC<AIScenarioInlineFormProps> = ({
  formData,
  onFormDataChange,
  onSubmit,
  templates,
  isSubmitting = false
}) => {
  const isValid = validateChatBotForm(formData);

  const { handleSubmit } = useFormSubmission({
    onSubmit: data => onSubmit(data),
    closeOnSubmit: false
  });

  return (
    <FormContainer>
      <Title>Create an AI Scenario Practice</Title>

      <AIScenarioForm
        formData={formData}
        onFormDataChange={onFormDataChange}
        onSubmit={event => handleSubmit(event, formData)}
        isValid={isValid}
        templates={templates}
        isSubmitting={isSubmitting}
      />
    </FormContainer>
  );
};
